import { render, staticRenderFns } from "./app-main.vue?vue&type=template&id=9cec9186&scoped=true&"
import script from "./app-main.vue?vue&type=script&lang=js&"
export * from "./app-main.vue?vue&type=script&lang=js&"
import style0 from "./app-main.vue?vue&type=style&index=0&id=9cec9186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cec9186",
  null
  
)

export default component.exports